import { render } from "./wysiwyg.vue?vue&type=template&id=95656d78"
import script from "./wysiwyg.vue?vue&type=script&lang=js"
export * from "./wysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/wysiwyg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95656d78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95656d78', __exports__)) {
    console.log('reload')
    api.reload('95656d78', __exports__)
  }
  
  module.hot.accept("./wysiwyg.vue?vue&type=template&id=95656d78", () => {
    console.log('re-render')
    api.rerender('95656d78', render)
  })

}


export default __exports__